/**
 * Model configuration
 */
export const config = {
    modelName: 'settings',
} as const;
